import React, { Component } from 'react';
import './base.scss';

class CoEContainer extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='coe'>
        <h4>
          This version of the Center of Excellence app has been discontinued.
          <br />
          Please refer to the Splunk Success Framework available at <a href='https://lantern.splunk.com/'>lantern.splunk.com</a>.
        </h4>
        <h4>
          If you require further assistance please contact your account team.
        </h4>
      </div>
    );
  }
}

export default CoEContainer;



// WEBPACK FOOTER //
// ./src/CoE/CoEContainer.js